'use strict';

angular.module('buyers')
.directive('propertyActionMenu', function() {
    return {
        link : function (scope, element, attrs) {
            $(element).dropdown();
        }
    };
});